module.exports = __webpack_public_path__ + "3371653310c15d2a37b649abe6e1ee70.svg";